<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('approvalWorkFlow.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('approvalWorkFlow.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>
              {{ record.approval_type ? record.approval_type.app_type : '' }}
            </td>
            <td class="text-center">{{ record.escalate_after_xx_hours }}</td>
            <td class="text-center">{{ record.escalate_times }}</td>
            <td>{{ record.approver_notification_template }}</td>
            <td>{{ record.initiator_notification_template }}</td>
            <td class="text-center" v-if="record.is_enabled">
              <span class="badge badge-success">Yes</span>
            </td>
            <td class="text-center" v-else>
              <span class="badge badge-danger">No</span>
            </td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="showEditForm(record)"
              >
                <i class="fa fa-edit" aria-hidden="true"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('approvalWorkFlow.addCondition')"
                class="text-primary"
                @click.prevent="addCondition(record)"
              >
                <i class="far fa-list-alt"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
import EditFormComponent from './edit'
import AddConditionForm from './add-condition'
export default {
  name: 'approvalWorkFlow',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('approvalWorkFlow', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('approvalWorkFlow.approvalType')
        },
        {
          name: this.$t('approvalWorkFlow.escalateAfterHours'),
          style: 'text-align:center'
        },
        {
          name: this.$t('approvalWorkFlow.escalateTimes'),
          style: 'text-align:center'
        },
        {
          name: this.$t('approvalWorkFlow.approverNotificationTemplate')
        },
        {
          name: this.$t('approvalWorkFlow.initiatorNotificationTemplate')
        },
        {
          name: this.$t('approvalWorkFlow.isEnabled'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    search: {
      get() {
        return this.$store.state.approvalWorkFlow.search
      },
      set(newValue) {
        this.$store.commit('approvalWorkFlow/SET_SEARCH', newValue)
        this.$store.commit('approvalWorkFlow/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showEditForm(editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    addCondition(editData) {
      this.$store.commit('approvalWorkFlow/SET_EDIT_DATA', editData)
      this.$modal.show(
        AddConditionForm,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('approvalWorkFlow/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('approvalWorkFlow/RESET_STATE')
    next()
  }
}
</script>
